import { Component, OnInit, Input, AfterViewInit, ViewChild } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';

import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

import { environment } from '../../../environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';
import { NoteService } from '../../services/note.service';

import { DisbursementScheduleListItem } from 'src/app/models/note';

@Component({
  selector: 'app-note-disbursement-schedule-list',
  templateUrl: './note-disbursement-schedule-list.component.html',
  styleUrls: ['./note-disbursement-schedule-list.component.scss']
})
export class NoteDisbursementScheduleListComponent implements OnInit, AfterViewInit {
  private _noteId = 0;

  @Input()
  set noteId(noteId: number) {
    this._noteId = noteId || 0;
    this.getData();
  }
  get noteId(): number {
    return this._noteId;
  }

  // Have to use the following ElementDisplayStyle variables and ngStyle to show/hide table elements
  // This because the table paginator will not attach correctly otherwise - this is a work around for a known issue
  private _hideElementDisplayStyle = 'none';
  private _showElementDisplayStyle = 'inline';
  private _showElementDisplayStyleIE = 'inline-block';

  private _handleError: HandleError;
  private _logging = environment.logging;

  isBrowserIE = /msie\s|trident\//i.test(window.navigator.userAgent);

  showSpinner = false;

  notesDisbursementScheduleList: (DisbursementScheduleListItem)[] = [];

  // DataTable
  tableDisplayedColumns = ['scheduledDisbursementDate', 'grossDisbursementAmount', 'disbursementStatus'];
  tableDataSource = new MatTableDataSource<DisbursementScheduleListItem>(this.notesDisbursementScheduleList);
  tableDisplayStyle: string = this._hideElementDisplayStyle;
  tableDisplayStyleIE: string = this._hideElementDisplayStyle;
  notesDisbursementScheduleListFound = false;

  constructor(private _errorHandler: ErrorHandler, private _noteService: NoteService, public media: MediaObserver) {
    this._handleError = _errorHandler.createHandleError('NoteDisbursementScheduleListComponent');
  }

  ngOnInit() {
    this.notesDisbursementScheduleListFound = true;
    this.tableDisplayStyle = this.notesDisbursementScheduleListFound ? this._showElementDisplayStyle : this._hideElementDisplayStyle;
    this.tableDisplayStyleIE = this.notesDisbursementScheduleListFound ? this._showElementDisplayStyleIE : this._hideElementDisplayStyle;
  }

  ngAfterViewInit() {}

  getData(): void {
    this.showSpinner = true;
    this.getNotesDisbursementScheduleList(this._noteId);
  }

  getNotesDisbursementScheduleList(noteId: number): void {
    this.showSpinner = true;
    this._noteService.getNoteDisbursementScheduleList(noteId).subscribe(
      resultArray => {
        this.notesDisbursementScheduleList = resultArray;
        if (this._logging.serviceCallTraceLog) {
          console.log('NoteDisbursementScheduleListComponent.getNotesDisbursementScheduleList :: result.length = ' + resultArray.length);
        }
        if (this._logging.serviceDataTraceLog) {
          console.log('NoteDisbursementScheduleListComponent.getNotesDisbursementScheduleList :: result = ' + JSON.stringify(resultArray));
        }
        this.tableDataSource = new MatTableDataSource<DisbursementScheduleListItem>(this.notesDisbursementScheduleList);
        this.notesDisbursementScheduleListFound = resultArray.length > 0;
        this.tableDisplayStyle = this.notesDisbursementScheduleListFound ? this._showElementDisplayStyle : this._hideElementDisplayStyle;
        this.tableDisplayStyleIE = this.notesDisbursementScheduleListFound
          ? this._showElementDisplayStyleIE
          : this._hideElementDisplayStyle;
        this.getDataComplete();
      },
      error => this._handleError('getNotesDisbursementScheduleList', error)
    );
  }

  getDataComplete(): void {
    this.showSpinner = false;
  }
}
